(function () {
  document.querySelectorAll('[data-velvety-collection-grid]').forEach(initGrid);

  function initGrid(root) {
    initSort(root);
    initFilterForm(root);
    initColorBuckets(root);
    initColorShowMore(root);
    initPriceSlider(root);
    initLoadMore(root);
  }

  /* "Show more / Show less" toggle on the Colors filter group.
     Reveals/hides any color buckets beyond the first 5 (controlled by
     the [hidden] attr applied server-side in the snippet). */
  function initColorShowMore(root) {
    root.querySelectorAll('[data-velvety-color-show-more]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const list = btn.previousElementSibling;
        if (!list) return;
        const extras = list.querySelectorAll('.velvety-filter-value__extra');
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        extras.forEach(function (li) {
          if (expanded) li.setAttribute('hidden', '');
          else li.removeAttribute('hidden');
        });
        btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        btn.textContent = expanded
          ? btn.getAttribute('data-label-more') || 'Show more'
          : btn.getAttribute('data-label-less') || 'Show less';
      });
    });
  }

  /* Color buckets: clicking a bucket toggle flips every hidden child checkbox
     for variant colour values that map into that bucket, then submits the form.
     The hidden inputs are the real Shopify filter params (filter.v.option.color=Red);
     the bucket trigger is just a UI shorthand. */
  function initColorBuckets(root) {
    const wrap = root.querySelector('[data-velvety-color-buckets]');
    if (!wrap) return;
    wrap.querySelectorAll('[data-velvety-color-bucket-trigger]').forEach(function (trigger) {
      trigger.addEventListener('change', function () {
        const li = trigger.closest('li');
        if (!li) return;
        const children = li.querySelectorAll('[data-velvety-color-bucket-child]');
        children.forEach(function (cb) { cb.checked = trigger.checked; });
        /* Bubble a real "filter changed" change event so initFilterForm picks it up. */
        const ev = new Event('change', { bubbles: true });
        if (children[0]) children[0].dispatchEvent(ev);
        else trigger.dispatchEvent(ev);
      });
    });
  }

  function initSort(root) {
    const applySort = function (value) {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    };
    const sort = root.querySelector('[data-velvety-sort]');
    if (sort) sort.addEventListener('change', function () { applySort(sort.value); });
    /* Mobile sort is the bottom-sheet ([data-velvety-sort-sheet]); its options
       carry data-velvety-sort-value and reuse the document-level handler. */
  }

  /* Custom Sort By dropdown — toggle the menu, click outside / Esc closes,
     and clicking an item updates the URL via the hidden native <select>'s
     change event (which initSort listens to). */
  function setSortMenuOpen(wrap, open) {
    const btn = wrap.querySelector('[data-velvety-sort-toggle]');
    const menu = wrap.querySelector('[data-velvety-sort-menu]');
    if (!btn || !menu) return;
    if (open) {
      menu.removeAttribute('hidden');
      btn.setAttribute('aria-expanded', 'true');
    } else {
      menu.setAttribute('hidden', '');
      btn.setAttribute('aria-expanded', 'false');
    }
  }

  document.addEventListener('click', function (e) {
    const toggle = e.target && e.target.closest && e.target.closest('[data-velvety-sort-toggle]');
    const item = e.target && e.target.closest && e.target.closest('[data-velvety-sort-value]');
    if (toggle) {
      e.preventDefault();
      const wrap = toggle.closest('[data-velvety-sort-wrap]');
      if (!wrap) return;
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      /* Close any other open menus first */
      document.querySelectorAll('[data-velvety-sort-wrap]').forEach(function (w) {
        if (w !== wrap) setSortMenuOpen(w, false);
      });
      setSortMenuOpen(wrap, open);
      return;
    }
    if (item) {
      e.preventDefault();
      const value = item.getAttribute('data-velvety-sort-value');
      const wrap = item.closest('[data-velvety-sort-wrap]');
      const root = item.closest('[data-velvety-collection-grid]');
      const select = root && root.querySelector('[data-velvety-sort]');
      if (select) {
        select.value = value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (wrap) setSortMenuOpen(wrap, false);
      return;
    }
    /* Click outside any sort menu */
    if (!e.target.closest || !e.target.closest('[data-velvety-sort-wrap]')) {
      document.querySelectorAll('[data-velvety-sort-wrap]').forEach(function (w) {
        setSortMenuOpen(w, false);
      });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-velvety-sort-wrap]').forEach(function (w) {
      setSortMenuOpen(w, false);
    });
  });

  function initFilterForm(root) {
    const form = root.querySelector('[data-velvety-filter-form]');
    if (!form) return;
    let debounce;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-velvety-filter-input], [data-velvety-price-input]')) return;
      clearTimeout(debounce);
      debounce = setTimeout(function () { submitFilters(root, form); }, 250);
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      submitFilters(root, form);
    });
  }

  function buildFilterUrl(form) {
    const data = new FormData(form);
    const params = new URLSearchParams();
    for (const [k, v] of data.entries()) {
      if (v === '' || v == null) continue;
      /* Strip commas/spaces from price params so Shopify gets a raw number
         even though the visible input shows "1,000.00". */
      const isPriceParam = /price\.(gte|lte)$/.test(k);
      const out = isPriceParam ? String(v).replace(/[^0-9.]/g, '') : v;
      params.append(k, out);
    }
    const url = new URL(form.getAttribute('action') || window.location.pathname, window.location.origin);
    url.search = params.toString();
    return url;
  }

  function isMobileDrawerOpen(root) {
    var sb = root.querySelector('[data-velvety-filter-sidebar]');
    /* Only a real drawer at <=989px (the CSS breakpoint where .is-open becomes
       a fixed overlay). Above that the sidebar is a static column, so don't
       suppress the sidebar swap — keeps desktop refreshing normally even if the
       Filter pill was clicked. */
    return !!(
      sb &&
      sb.classList.contains('is-open') &&
      window.matchMedia('(max-width: 989px)').matches
    );
  }

  function updateMobileResultCount(root, newSection) {
    var cur = root.querySelector('[data-velvety-mobile-result-count]');
    var next = newSection.querySelector('[data-velvety-mobile-result-count]');
    if (cur && next) cur.textContent = next.textContent;
  }

  /* AJAX filter swap — fetch the filtered URL, parse the new section,
     and surgically replace the parts that changed (grid, count, sidebar,
     pagination). Preserves accordion open/close state. */
  function submitFilters(root, form) {
    const url = buildFilterUrl(form);
    /* On mobile the filter drawer is open while the user is selecting. Swapping
       the sidebar would drop its `.is-open` state AND the in-progress checkbox
       selections — that's the auto-close bug. So when the drawer is open we keep
       the sidebar untouched and only refresh the grid/count behind it; the user
       can pick several filters and tap "Show Result" to close. */
    const keepDrawer = isMobileDrawerOpen(root);
    setGridLoading(root, true);

    fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector('[data-velvety-collection-grid][data-section-id="' + root.dataset.sectionId + '"]')
          || doc.querySelector('[data-velvety-collection-grid]');
        if (!newSection) {
          window.location.href = url.toString();
          return;
        }
        swapPart(root, newSection, '[data-velvety-grid]');
        swapPart(root, newSection, '.velvety-collection-grid__filter-pill-count');
        swapPart(root, newSection, '.velvety-collection-grid__footer');

        if (keepDrawer) {
          updateMobileResultCount(root, newSection);
        } else {
          swapSidebar(root, newSection);
          /* Re-init handlers bound to the new sidebar markup */
          initPriceSlider(root);
          initColorBuckets(root);
          initColorShowMore(root);
        }

        window.history.replaceState({}, '', url.toString());
        setGridLoading(root, false);
      })
      .catch(function () {
        /* Network error — fall back to full reload */
        window.location.href = url.toString();
      });
  }

  function swapPart(root, newSection, selector) {
    const cur = root.querySelector(selector);
    const next = newSection.querySelector(selector);
    if (cur && next) cur.replaceWith(next);
  }

  function swapSidebar(root, newSection) {
    const curSidebar = root.querySelector('[data-velvety-filter-sidebar]');
    const newSidebar = newSection.querySelector('[data-velvety-filter-sidebar]');
    if (!curSidebar || !newSidebar) return;
    /* Remember which accordions were open so the swap doesn't collapse them. */
    const openParams = new Set();
    curSidebar.querySelectorAll('details[open] [data-velvety-filter-group], details.velvety-filter-group[open]').forEach(function () {});
    curSidebar.querySelectorAll('details.velvety-filter-group').forEach(function (d, i) {
      if (d.open) openParams.add(i);
    });
    curSidebar.replaceWith(newSidebar);
    /* Restore open state by index */
    root.querySelectorAll('details.velvety-filter-group').forEach(function (d, i) {
      d.open = openParams.has(i);
    });
    /* Re-bind the form on the new sidebar */
    initFilterForm(root);
  }

  function setGridLoading(root, on) {
    const grid = root.querySelector('[data-velvety-grid]');
    if (!grid) return;
    grid.style.opacity = on ? '0.55' : '';
    grid.style.pointerEvents = on ? 'none' : '';
    grid.style.transition = 'opacity 0.15s ease';
  }

  function initPriceSlider(root) {
    const wrapper = root.querySelector('[data-velvety-filter-price]');
    if (!wrapper) return;
    const slider = wrapper.querySelector('[data-velvety-price-slider]');
    const fill = wrapper.querySelector('[data-velvety-price-fill]');
    const thumbMin = wrapper.querySelector('[data-velvety-price-thumb="min"]');
    const thumbMax = wrapper.querySelector('[data-velvety-price-thumb="max"]');
    const inputMin = wrapper.querySelector('[data-velvety-price-input="min"]');
    const inputMax = wrapper.querySelector('[data-velvety-price-input="max"]');
    const rangeMax = parseFloat(wrapper.getAttribute('data-range-max')) || 0;
    if (!slider || rangeMax <= 0) return;

    function clamp(n, lo, hi) { return Math.max(lo, Math.min(hi, n)); }

    /* Inputs display formatted values ("1,000.00"); strip non-digits before
       parseFloat so slider math + paint() see the raw number. */
    function parseAmount(v) {
      return parseFloat(String(v == null ? '' : v).replace(/[^0-9.]/g, '')) || 0;
    }

    function formatAmount(n) {
      if (!isFinite(n)) return '0';
      /* Match the AED storefront format: comma thousands, two decimals. */
      return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    function readValues() {
      const mn = clamp(parseAmount(inputMin.value), 0, rangeMax);
      const mx = clamp(parseAmount(inputMax.value) || rangeMax, 0, rangeMax);
      return [Math.min(mn, mx), Math.max(mn, mx)];
    }

    function paint() {
      const [mn, mx] = readValues();
      const pctMin = (mn / rangeMax) * 100;
      const pctMax = (mx / rangeMax) * 100;
      thumbMin.style.left = pctMin + '%';
      thumbMax.style.left = pctMax + '%';
      fill.style.left = pctMin + '%';
      fill.style.width = (pctMax - pctMin) + '%';
    }

    paint();
    inputMin.addEventListener('input', paint);
    inputMax.addEventListener('input', paint);
    /* On blur, reformat with thousands separators */
    inputMin.addEventListener('blur', function () { inputMin.value = formatAmount(parseAmount(inputMin.value)); });
    inputMax.addEventListener('blur', function () { inputMax.value = formatAmount(parseAmount(inputMax.value)); });

    let dragging = null;
    function onPointerDown(which) {
      return function (e) {
        e.preventDefault();
        dragging = which;
        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp, { once: true });
      };
    }
    function onPointerMove(e) {
      if (!dragging) return;
      const rect = slider.getBoundingClientRect();
      const pct = clamp((e.clientX - rect.left) / rect.width, 0, 1);
      const value = Math.round(pct * rangeMax);
      const [curMin, curMax] = readValues();
      if (dragging === 'min') {
        inputMin.value = formatAmount(Math.min(value, curMax));
      } else {
        inputMax.value = formatAmount(Math.max(value, curMin));
      }
      paint();
    }
    function onPointerUp() {
      dragging = null;
      document.removeEventListener('pointermove', onPointerMove);
      inputMin.dispatchEvent(new Event('change', { bubbles: true }));
    }
    thumbMin.addEventListener('pointerdown', onPointerDown('min'));
    thumbMax.addEventListener('pointerdown', onPointerDown('max'));
  }

  function initLoadMore(root) {
    const btn = root.querySelector('[data-velvety-loadmore]');
    if (!btn) return;
    const grid = root.querySelector('[data-velvety-grid]');
    const showingTo = root.querySelector('[data-velvety-showing-to]');
    const showingTotal = root.querySelector('[data-velvety-showing-total]');
    const progressFill = root.querySelector('[data-velvety-progress-fill]');
    const label = btn.querySelector('[data-velvety-loadmore-label]');
    const spinner = btn.querySelector('[data-velvety-loadmore-spinner]');

    btn.addEventListener('click', function () {
      const nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;
      btn.disabled = true;
      if (label) label.textContent = 'Loading';
      if (spinner) spinner.removeAttribute('hidden');

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newCells = doc.querySelectorAll('[data-velvety-grid] > .velvety-collection-grid__cell');
          newCells.forEach(function (cell) { grid.appendChild(cell); });

          const newBtn = doc.querySelector('[data-velvety-loadmore]');
          const newShowingTo = doc.querySelector('[data-velvety-showing-to]');
          const newProgress = doc.querySelector('[data-velvety-progress-fill]');

          if (newShowingTo && showingTo) showingTo.textContent = newShowingTo.textContent;
          if (newProgress && progressFill) progressFill.style.width = newProgress.style.width;

          if (newBtn) {
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.disabled = false;
            if (label) label.textContent = 'Load More';
            if (spinner) spinner.setAttribute('hidden', '');
          } else {
            btn.remove();
          }

          if (window.history && window.history.replaceState) {
            try {
              const url = new URL(window.location.href);
              const pageMatch = nextUrl.match(/[?&]page=(\d+)/);
              if (pageMatch) url.searchParams.set('page', pageMatch[1]);
              window.history.replaceState({}, '', url.toString());
            } catch (e) { /* noop */ }
          }
        })
        .catch(function () {
          btn.disabled = false;
          if (label) label.textContent = 'Load More';
          if (spinner) spinner.setAttribute('hidden', '');
        });
    });
  }

  /* ============================================================
     Mobile filter + sort — event delegation on document.
     Survives section re-renders and any binding-timing issue
     (the prior per-element addEventListener loop didn't fire
     reliably on iOS Safari in real-phone testing).
     ============================================================ */
  function setFilterOpen(open) {
    var sidebar = document.querySelector('[data-velvety-filter-sidebar]');
    if (!sidebar) return;
    if (open) {
      sidebar.classList.add('is-open');
      document.body.classList.add('velvety-mobile-nav-open');
    } else {
      sidebar.classList.remove('is-open');
      document.body.classList.remove('velvety-mobile-nav-open');
    }
  }

  function setSortOpen(open) {
    var sheet = document.querySelector('[data-velvety-sort-sheet]');
    if (!sheet) return;
    if (open) {
      sheet.removeAttribute('hidden');
      /* setTimeout (not rAF) so the slide-up runs even in embedded render
         contexts where rAF is throttled. */
      setTimeout(function () { sheet.classList.add('is-open'); }, 10);
      document.body.classList.add('velvety-mobile-nav-open');
    } else {
      sheet.classList.remove('is-open');
      document.body.classList.remove('velvety-mobile-nav-open');
      setTimeout(function () { sheet.setAttribute('hidden', 'hidden'); }, 280);
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-velvety-filter-open]')) { setFilterOpen(true); return; }
    if (t.closest('[data-velvety-filter-close]')) { setFilterOpen(false); return; }
    if (t.closest('[data-velvety-sort-open]')) { setSortOpen(true); return; }
    if (t.closest('[data-velvety-sort-close]')) { setSortOpen(false); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    setFilterOpen(false);
    setSortOpen(false);
  });

  document.addEventListener('change', function (e) {
    var input = e.target && e.target.matches && e.target.matches('[data-velvety-mobile-sort-input]') ? e.target : null;
    if (!input || !input.checked) return;
    var sheet = document.querySelector('[data-velvety-mobile-sort]');
    if (sheet) {
      sheet.querySelectorAll('.velvety-mobile-sort__option').forEach(function (lbl) {
        var i = lbl.querySelector('input');
        lbl.classList.toggle('is-selected', i && i.checked);
      });
    }
    var sortSelect = document.querySelector('[data-velvety-sort]');
    if (sortSelect) {
      sortSelect.value = input.value;
      sortSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setTimeout(function () { setSortOpen(false); }, 180);
  });
})();
